import axios from 'axios';

export const QueueAppsFiltersApi = {
  getKindergartens: (filter) => axios.get(
    `/api/public/data/service_provider_with_pre_school_graduation_with_filters`, {params: filter}
  ),
};
